import React from 'react';

const LanguageFilter = ({ language, setLanguage }) => {
  return (
    <div className="filter">
      <label>Language: </label>
      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
        <option value="JavaScript">JavaScript</option>
        <option value="Python">Python</option>
        <option value="Java">Java</option>
        <option value="Machine">Machine Learning</option>
        <option value="DataScience">Data Science</option>
       {/* <option value="Prompt">Prompt Engineering</option> */}
        <option value="C++">C++</option>
        <option value="PHP">PHP</option>
      </select>
    </div>
  );
};

export default LanguageFilter;
